import styled, {keyframes} from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Form} from 'components/ui-kit/Form';
import {Hint} from 'components/ui-kit/Hint';
import {Title} from 'components/ui-kit/Title';
import {breakpoint, colors} from 'theme';

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
    //margin-top: 20px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const SpinnerLayer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;

    > * {
        position: sticky;
        top: 20%;
        bottom: 20%;
    }
`;

export const CheckboxWrapper = styled.div`
    color: #59606a;
    font-weight: 500;
    font-size: 14px;
`;

export const CustomTitle = styled(Title)`
    color: #59606a;
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 0;
`;

export const TitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 40px;
    flex-wrap: wrap;
`;

export const CustomSubtitle = styled.div`
    color: #59606a;
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 20px;
`;

export const FormFields = styled.div`
    display: grid;
    grid-row-gap: 10px;
    grid-column-gap: 30px;
    margin-bottom: 20px;

    @media (min-width: ${breakpoint.tablet}) {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;

export const Field = styled(Hint)`
    display: flex;
    flex-flow: column wrap;

    > span {
        font-size: 12px;
        color: ${colors.textSecondary};
        padding-bottom: 6px;
        margin-top: 2px;
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-flow: row nowrap;
    gap: 16px;
    justify-content: flex-end;
`;

export const SubmitButton = styled(Button)`
    max-width: 240px;
`;

export const BackButton = styled(Button)`
    max-width: 240px;
    color: ${colors.textPrimary};
    text-decoration: none;
`;

export const HeadlineControlContainer = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 12px;
`;
